import React from 'react'
import Navbar from '../inc/Navbar'
import diwali2025 from "../images/Diwali 2025.jpg";
import "./Home.css";
import ScrollToTop from "react-scroll-to-top";
import Aboutus from './Aboutus';
import ShowroomPhoto from './ShowroomPhoto';


function Home() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <div className="album py-0">
        <div className="container">
          <div className='borderbox'>
            <img src={diwali2025} className="d-block w-100" alt="Aneek Textile" />
          </div>
        </div>
      </div>
      <ScrollToTop smooth top="100" color="maroon"/>
      <br />

      <div className='ranaghatsaree'>
        <div className="album py-0">
          <div className="container">

            <marquee>
              <h4 className='mt-3'>Welcome to Aneek Textiles | Aistala, Ranaghat, Nadia, Pin-741201, WB |  India</h4>
            </marquee>
          </div>
        </div>
      </div>
       <div className="album py-0">
          <div className="container">
            <center>
      <h3 style={{color:"maroon"}} className='mt-3'>Learn More: <a href='https://www.balajisaree.com/'>www.balajisaree.com</a></h3>

            </center>
            </div>
          </div>
    
      <Aboutus />
      <br />

      <div className='backgallery'>
        <br/>

        <div className="album py-0">
          <div className="container">
            <h1><b>Showroom Gallery</b></h1>
          </div>
        </div>

        <ShowroomPhoto/>
      </div>
    

    </div >
  )
}

export default Home